function number(x) {
  return +x;
}

export { number as default };
